import { Subject } from 'rxjs';
import AppSettings from '../app.settings';

export class IdleTimer {
  public eventHandler: () => void;
  public interval: ReturnType<typeof setTimeout>;
  public timeoutTracker: ReturnType<typeof setTimeout>;
  public expirationTime: number;
  private lastReportedActivityTime: number;

  public constructor(
    private timeout: number,
    private userInactiveSubject: Subject<void>,
    private userActivityDetectedSubject: Subject<void>,
  ) {
    this.eventHandler = this.onActivityDetected.bind(this);
    this.initializeListeners();
    this.startInterval();
  }

  public cleanUp(): void {
    clearInterval(this.interval);
    this.interval = null;
    window.removeEventListener('mousemove', this.eventHandler);
    window.removeEventListener('scroll', this.eventHandler);
    window.removeEventListener('keydown', this.eventHandler);
  }

  public restart(): void {
    this.lastReportedActivityTime = Date.now();
    this.updateExpiredTime();
  }

  private startInterval(): void {
    this.lastReportedActivityTime = Date.now();
    this.updateExpiredTime();

    this.interval = setInterval(() => {
      if (this.expirationTime < Date.now() && this.interval) {
        this.userInactiveSubject.next();
        this.cleanUp();
      }
    }, 1000);
  }

  private onActivityDetected(): void {
    // Buffer prolongation events so that we don't overload the server with too frequent calls
    const currentTimestamp: number = Date.now();
    if (currentTimestamp - this.lastReportedActivityTime >= AppSettings.SESSION_PROLONG_THRESHOLD) {
      this.userActivityDetectedSubject.next();
      this.lastReportedActivityTime = currentTimestamp;
    }

    // Reactivate time, new measurement of inactivity starts now
    this.updateExpiredTime();
  }

  private updateExpiredTime(): void {
    if (this.timeoutTracker) {
      clearTimeout(this.timeoutTracker);
    }

    this.timeoutTracker = setTimeout(() => {
      this.expirationTime = Date.now() + this.timeout;
    }, 300);
  }

  private initializeListeners(): void {
    window.addEventListener('mousemove', this.eventHandler);
    window.addEventListener('scroll', this.eventHandler);
    window.addEventListener('keydown', this.eventHandler);
  }
}
